var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "ct-header ct-header-fixed" }, [
    _c(
      "nav",
      {
        staticClass: "navbar navbar-expand-sm navbar-light w-100",
        class: _vm.clsLeftBordered,
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "button",
              {
                staticClass: "navbar-toggler-sidebar",
                class: _vm.classToggler,
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "",
                  "aria-controls": "",
                  "aria-expanded": "false",
                  "aria-label": "Toggle sidebar",
                },
                on: {
                  click: function ($event) {
                    return _vm.toggleMenuSideBar()
                  },
                },
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "navbar-brand py-0 ml-sm-2 mr-0 mr-md-2",
                class: { "d-lg-none": _vm.$route.meta.hideHeaderName },
                attrs: { to: { name: _vm.initialPagePlatform } },
              },
              [
                _c("div", { staticClass: "row no-gutters" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _vm.hasNavTopMenu
                        ? [
                            _c("img", {
                              staticClass: "d-none d-lg-block only-img",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass:
                                "d-none d-sm-block d-lg-none only-img",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header-tablet.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "d-block d-sm-none only-img",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header-mobile.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm.moduleName
                              ? _c(
                                  "h6",
                                  {
                                    staticClass:
                                      "text-nowrap d-block d-sm-none m-0 module-name",
                                  },
                                  [_vm._v(_vm._s(_vm.moduleName))]
                                )
                              : _vm._e(),
                          ]
                        : [
                            _c("img", {
                              staticClass: "d-none d-lg-block",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "d-none d-sm-block d-lg-none",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header-tablet.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "d-block d-sm-none",
                              attrs: {
                                alt: "Logo",
                                src: _vm.assetsPathGlobalPlatform(
                                  "/logo-header-mobile.svg"
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm.moduleName
                              ? _c(
                                  "h6",
                                  {
                                    staticClass: "text-nowrap m-0 module-name",
                                  },
                                  [_vm._v(_vm._s(_vm.moduleName))]
                                )
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "navbar-collapse justify-content-between align-items-center w-auto w-sm-100",
          },
          [
            _c(
              "div",
              {
                staticClass: "navbar-nav text-center",
                class: {
                  "mx-auto": !_vm.activeSearchPortal,
                  "navbar--portal": _vm.activeSearchPortal,
                },
              },
              [
                _vm.activeSearchPanel
                  ? _c("search-box", {
                      key: "search-box",
                      attrs: { moduleCode: _vm.moduleCode },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "nav navbar-nav flex-row justify-content-end flex-nowrap",
              },
              [
                _vm._l(_vm.tools, function (tool) {
                  return [
                    _c(`${tool.component}HeaderTool`, {
                      key: tool.component,
                      tag: "component",
                      attrs: {
                        title: _vm.$t(tool.title),
                        moduleCode: _vm.moduleCode,
                        propIdPanel: tool.id ?? tool.component,
                        hasNavTopMenu: _vm.hasNavTopMenu,
                      },
                    }),
                  ]
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown" },
                  [
                    _vm.$auth.check()
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "header-icon",
                              attrs: {
                                href: "#",
                                role: "button",
                                id: "dropdownMenuUser",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                "aria-haspopup": "true",
                              },
                            },
                            [
                              _c("div", { staticClass: "media topbar-user" }, [
                                _c("img", {
                                  staticClass:
                                    "align-self-center profile-image ml-1 ml-sm-2 ml-md-3",
                                  attrs: {
                                    src: _vm.$auth.user().photo
                                      ? _vm.$auth.user().photo
                                      : _vm.avatar,
                                    title: [_vm.$auth.user().name],
                                    "data-toggle": "tooltip-city",
                                    alt: _vm.$auth.user().name,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "media-body align-self-center",
                                    attrs: {
                                      title: _vm.$t(`auth.user.menu`),
                                      "data-toggle": "tooltip-city",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-none d-md-flex flex-column text-left p-0 ml-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline-block text-welcome",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    `auth.user.prefix-name-welcome`
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline-block text-username text-truncate text-truncate-header",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$auth.user().name) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu dropdown-menu-animated dropdown-lg",
                              attrs: {
                                "aria-labelledby": "dropdownMenuUser",
                                "x-placement": "bottom-start",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-header bg-trans-gradient d-flex flex-row py-3 rounded-top",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-fill align-items-start mt-1 mb-1 text-white",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "mb-2 mx-auto" },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "rounded-circle profile-image",
                                            attrs: {
                                              src: _vm.$auth.user().photo
                                                ? _vm.$auth.user().photo
                                                : _vm.avatar,
                                              alt: _vm.$auth.user().name,
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "info-card-text" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-truncate text-truncate-lg",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$auth.user().name)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-truncate text-truncate-md opacity-80",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$auth.user().email)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "dropdown-divider m-0",
                              }),
                              _vm._v(" "),
                              _vm.hasAccess("portal.profile")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        to: { name: "portal.profile" },
                                        "data-toggle": "modal",
                                        "data-target": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-i18n": "" } },
                                        [_vm._v(_vm._s(_vm.$t(`auth.profile`)))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "dropdown-divider m-0",
                              }),
                              _vm._v(" "),
                              _vm.hasAccess("portal.dashboard")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        to: { name: "portal.dashboard" },
                                        "data-toggle": "modal",
                                        "data-target": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-i18n": "" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t(`dashboard.title`))
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "dropdown-divider m-0",
                              }),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item fw-500 pt-3 pb-3",
                                  attrs: {
                                    to: { name: "portal.logout" },
                                    "data-toggle": "modal",
                                    "data-target": "",
                                  },
                                },
                                [
                                  _c("span", { attrs: { "data-i18n": "" } }, [
                                    _vm._v(_vm._s(_vm.$t(`auth.logout`))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "float-right fw-n" },
                                    [_vm._v("@cityhub")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "router-link",
                            {
                              staticClass: "header-icon ml-0 ml-sm-3",
                              attrs: {
                                to: { name: "portal.login" },
                                title: _vm.$t(`auth.login`),
                              },
                            },
                            [
                              _c("div", { staticClass: "media topbar-user" }, [
                                _c("img", {
                                  staticClass: "align-self-center",
                                  attrs: {
                                    src: _vm.loginIcon,
                                    alt: _vm.$t(`auth.login`),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "media-body align-self-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-none d-md-flex flex-column text-left p-0 ml-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline-block text-welcome font-small",
                                          },
                                          [_vm._v(_vm._s(_vm.$t(`auth.login`)))]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "navbar-toggler-icon" }, [
      _c("i", { staticClass: "fas fa-bars" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }